import {Injectable} from "@angular/core";
import {CollectionUtils} from '@app/shared/util/collections/collection-utils';
import * as gql from 'gql-query-builder';
import {map, Observable} from "rxjs";
import {BaseService} from "../../base-service";
import {APIPageInfo, GQLPagingParamsVariable, GRAPHQL_TYPES, HttpUtilityService, PagedModelFetchFn, PagingParams} from "../../http-utility-service";
import {SustainabilityRatingMeasure, SustainabilityRatingMeasureId, SustainabilityRatingMeasureImpl} from './sustainability-rating-measures.interface';


export interface SustainabilityRatingMeasureSearchTerm {
  sustainability_rating_measure_id?: SustainabilityRatingMeasureId;
  sustainability_rating_measure_ids?: SustainabilityRatingMeasureId[];
}

export interface SustainabilityRatingMeasureFullSearchTerm extends SustainabilityRatingMeasureSearchTerm, PagingParams {}

const graphqlOperation = 'sustainability_rating_measures';

const graphqlVariables = {
  sustainability_rating_measure_id: {type: GRAPHQL_TYPES.INTEGER},
  sustainability_rating_measure_ids: {type: GRAPHQL_TYPES.INTEGER, list: true},
  ...GQLPagingParamsVariable
};

const graphqlFields = ['sustainability_rating_measure_id', 'name'];

@Injectable({providedIn: 'root'})
export class SustainabilityRatingMeasuresService extends BaseService {
  public static readonly modelMapping = {SustainabilityRatingMeasure: SustainabilityRatingMeasureImpl};

  private readonly FETCH_PAGE_SIZE: number = 500;
  private readonly DATA_KEY = graphqlOperation;
  private readonly gqlQuery = gql.query({
    operation: graphqlOperation,
    fields: graphqlFields,
    variables: graphqlVariables
  });

  constructor(private httpUtilityService: HttpUtilityService) {
    super();
  }

  getAllSustainabilityRatingMeasures(searchTerm?: SustainabilityRatingMeasureSearchTerm): Observable<SustainabilityRatingMeasure[]> {
    const request: PagedModelFetchFn<SustainabilityRatingMeasure[]> = (pageInfo: APIPageInfo) => {
      const params: SustainabilityRatingMeasureFullSearchTerm = {...searchTerm, start_index: pageInfo.first, limit: pageInfo.rows};
      return this.httpUtilityService.graphQL(this.gqlQuery, this.DATA_KEY, params);
    };
    return this.httpUtilityService.pageUntilComplete(request, {first: 0, rows: this.FETCH_PAGE_SIZE});
  }

  getSustainabilityRatingMeasureById(sustainabilityRatingMeasureId: SustainabilityRatingMeasureId): Observable<SustainabilityRatingMeasure> {
    return this.getAllSustainabilityRatingMeasures({sustainability_rating_measure_id: sustainabilityRatingMeasureId})
      .pipe(map(measures => CollectionUtils.only(measures)));
  }
}